import axios from '@axios'

export default {
    namespaced: true,
    state: {
        userPermissions: (() => {
            // const permissions = JSON.parse(localStorage.getItem('permission'))
            // return permissions ? permissions : []
        })()
    },
    getters: {},
    mutations: {
        UPDATE_USER_PERMISSIONS(state, data) {
            //state.userPermission = data
            localStorage.setItem('permission', JSON.stringify(data))
        },
    },
    actions: {
        fetchUserPermissions(ctx, {userId}) {
            return new Promise((resolve, reject) => {
                this.$http.get(`/admin/permissions/show/${userId}`).then(response => {
                        commit('UPDATE_USER_PERMISSIONS', response.data, {root: true})
                        resolve(response)
                    }).catch(error => reject(error))
            })
        },
    }
}
